import React from 'react';
import { SheetMusicLibrary } from '../SheetMusicLibrary';
import { ChevronLeftIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../providers/ThemeProvider';
export const SheetMusicPage = () => {
  const location = useLocation();
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  // Determine if user is a teacher or student based on the URL path
  const isTeacher = location.pathname.includes('teacher');
  const returnPath = isTeacher ? '/teacher-dashboard' : '/student-dashboard';
  return <>
      <div className="mx-auto" data-id="element-6816">
        <div className="flex items-center mb-6" data-id="element-6817">
          <Link to={returnPath} className={`inline-flex items-center mr-4 ${isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-6818">
            <ChevronLeftIcon className="h-5 w-5 mr-1" data-id="element-6819" />
            <span data-id="element-6820">Back to Dashboard</span>
          </Link>
          <h1 className={`text-2xl font-serif font-bold ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-6821">
            Sheet Music Library
          </h1>
        </div>
        <SheetMusicLibrary darkMode={isDark} data-id="element-6822" />
      </div>
    </>;
};